import { Box, Typography } from "@mui/material";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { formatPct } from "@/lib/formatters";

interface Props {
  value: number;             // decimal, e.g. 0.0234 for +2.34%
  suffix?: string;           // optional trailing label
  size?: "sm" | "md" | "lg";
  variant?: "chip" | "plain";
}

export function DeltaBadge({ value, suffix, size = "md", variant = "plain" }: Props) {
  const positive = value >= 0;
  const Icon = positive ? ArrowUpward : ArrowDownward;
  const color = positive ? "primary.main" : "error.main";
  const bg = positive ? "rgba(38,211,154,0.14)" : "rgba(255,91,91,0.14)";
  const fontSize = size === "sm" ? "0.75rem" : size === "lg" ? "1rem" : "0.875rem";
  const iconSize = size === "sm" ? 14 : size === "lg" ? 18 : 16;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        color,
        ...(variant === "chip" && {
          bgcolor: bg,
          px: 1,
          py: 0.25,
          borderRadius: 2
        })
      }}
    >
      <Icon sx={{ fontSize: iconSize }} />
      <Typography
        sx={{
          fontSize,
          fontWeight: 700,
          fontFeatureSettings: '"tnum" 1',
          color: "inherit"
        }}
      >
        {formatPct(value)}
      </Typography>
      {suffix && (
        <Typography
          sx={{ fontSize, color: "text.secondary", fontWeight: 500, ml: 0.25 }}
        >
          {suffix}
        </Typography>
      )}
    </Box>
  );
}
